const setRenewalFieldCount = (dispatch, payload) =>
  dispatch({ type: "SET_RENEWAL_FIELD_COUNT", payload });

const submitMetricForm = (dispatch, payload) =>
  dispatch({ type: "SUBMIT_METRIC_FORM", payload });

const submitCalcForm = (dispatch, payload) =>
  dispatch({ type: "SUBMIT_CALC_FORM", payload });

const triggerCalcFormValidation = (dispatch, payload) =>
  dispatch({ type: "TRIGGER_CALC_FORM_VALIDATION", payload });

const setShowGratitudeModal = (dispatch, payload) =>
  dispatch({ type: "SET_SHOW_GRATITUDE_MODAL", payload });

const setCalcFormData = (dispatch, payload) =>
  dispatch({ type: "SET_CALC_FORM_DATA", payload });

const submitGratitudeModal = (dispatch, payload) =>
  dispatch({ type: "SUBMIT_GRATITUDE_MODAL", payload });

export {
  setRenewalFieldCount,
  submitMetricForm,
  submitCalcForm,
  triggerCalcFormValidation,
  setShowGratitudeModal,
  setCalcFormData,
  submitGratitudeModal,
};
